import React from 'react';
import Page from '../../layout/Page';
import Settings from './Settings';
import Messaging from './Messaging';
import Details from './Details';
import Management from './Management';

const WashClub = ({ children, ...props }) => {

    return (
        <Page
            title='Wash Club Management'
            icon='car'
            tabs
        >
            <Management tab='Products' />
            <Settings tab='Settings' />
            <Details tab='Details' />
            <Messaging tab='Messaging' />
            {/* <PausedBilling tab='Pause Billing' /> */}
        </Page >
    );
}

export default WashClub;
